import template from './homepage.html'; // Import du template associé à ce component
import css from './homepage.css' // importer du css associé à ce component
import { HomepageController } from './homepage.controller.js'

// declaration et export du component MyComponent
export const HomepageComponent = {
  template: template,
  controller: HomepageController,
  controllerAs: 'HomepageController'
}



// WEBPACK FOOTER //
// ./src/client/pages/homepage/homepage.component.js